import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    productsGet,
    productsGetById,
    productCreate,
    productUpdate,
    productDelete
} from "api/menu/master-files/product-maintenance/requests";

export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCT_BY_ID_SUCCESS = "FETCH_PRODUCT_BY_ID_SUCCESS";

export const PRODUCTS_REQUEST_LOADING = "PRODUCTS_REQUEST_LOADING";
export const PRODUCTS_REQUEST_ERRORS = "PRODUCTS_REQUEST_ERRORS";

export const setLoading = () => ({
    type: PRODUCTS_REQUEST_LOADING
});

export const fetchProducts = (includeInactive = false) => dispatch => {
    dispatch(setLoading());
    productsGet(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_PRODUCTS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PRODUCTS_REQUEST_ERRORS));
        });
};

export const fetchProductById = (id) => dispatch => {
    productsGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_PRODUCT_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PRODUCTS_REQUEST_ERRORS));
        });
};

export const insertProduct = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    productCreate(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Product "${data.code}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorLoading(false));
            dispatch(defaultErrorHandler(error, PRODUCTS_REQUEST_ERRORS));
        });
};

export const updateProduct = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    productUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Product "${data.code}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteProduct = (id, code, callback = false) => dispatch => {
    dispatch(setLoading());
    productDelete(id)
        .then(() => {
            toast(`Product "${code}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PRODUCTS_REQUEST_ERRORS));
        });
};

export const clearProducts = () => dispatch => {
    dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: []
    });
};

export const clearSingleProduct = () => dispatch => {
    dispatch({
        type: FETCH_PRODUCT_BY_ID_SUCCESS,
        payload: []
    });
};
